import { Card ,Image,Col,Row} from "react-bootstrap";
import './Style/ServiceCard.css'
function ServiceCard(props){
    return(
        <>
            <Card style={{height:"10rem",width:"20rem",backgroundColor:"white"}}
            className="border-0 rounded-4 ServiceCard"
            >
                <Card.Body
                className="d-flex">
                    <Row className="align-items-center ">
                    <Col xs="3">
                    <Image fluid className="ServiceCardImg" src={props.img}/>
                    </Col>
                    <Col >
                    <p className="m-0 d-flex align-items-center"> {props.title}</p>
                    </Col>
                    </Row>
                    </Card.Body>
            </Card>
        </>
    )
}
export default ServiceCard;